<template>
	<div class="bg" ref="login">
		<el-container :style="'height:'+$store.state.height+'px'">
			<el-header class="header1" ID="header1" height="65px">
				<img @click="$router.push('/login')" src="../assets/login/logo.png" alt="" height="38px" class="logo">
				<el-button class="home-btn" type="text" @click="$router.push('/login')" v-show="$store.state.width>$store.state.minwidth"><i class="el-icon-back"></i>&nbsp;返回登录页</el-button>
			</el-header>
			<el-main>
				<div class="form_bg">
					<div class="form_header">
						<el-steps :active="active" finish-status="success" align-center>
							<el-step title="绑定手机"></el-step>
							<el-step title="完善信息"></el-step>
							<el-step title="注册成功"></el-step>
						</el-steps>
					</div>
					<div class="form_body">
						<div class="form_body1" v-if="active==0">
							<div class="root">
								<el-form :model="Register" ref="RegisterForm" label-width="0" class="RegisterForm">
									<el-form-item prop="phone">
										<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Register.phone" placeholder="请输入手机号">
											<template slot="prepend">手机号</template>
											<el-button style="background-color:skyblue;color:white" slot="append" type="button" @click="sendcode"
											 :disabled="disabled" v-if="disabled==false">发送验证码
											</el-button>
											<el-button slot="append" type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}
											</el-button>
										</el-input>
									</el-form-item>
									<el-form-item prop="验证码" class="code">
										<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Register.sendcode" placeholder="请输入验证码">
											<template slot="prepend">验证码</template>
										</el-input>
									</el-form-item>
									<el-form-item>
										<el-button :size="$store.state.width<$store.state.minwidth?'small':''" type="primary" @click="submitForm">下一步</el-button>
									</el-form-item>
								</el-form>
							</div>
						</div>
						<div class="form_body3" v-if="active==1">
							<el-form :model="Info" :rules="rules" ref="Info" label-width="80px" class="InfoForm">
								<el-form-item prop="mobile" label="手机号" class="mobile">
									<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Info.mobile" disabled></el-input>
								</el-form-item>
								<el-form-item prop="username" label="用户名" class="username">
									<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Info.username" placeholder="请输入用户名">	</el-input>
								</el-form-item>
								<el-form-item prop="city" label="单位地址">
									<el-cascader
									  :size="$store.state.width<$store.state.minwidth?'small':''"
									  :options="$store.state.address"
									  v-model="Info.city"
									  @focus="Info.city=[]"
									  :props="props"
									  class="width"
									  change-on-select>
									</el-cascader>
								</el-form-item>
								<el-form-item prop="company" label="单位名称" class="company">
									<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Info.company" placeholder="请输入单位名称"></el-input>
								</el-form-item>
								<el-form-item prop="password" label="账号密码" class="password">
									<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Info.password" placeholder="请输入密码" type="password"></el-input>
								</el-form-item>
								<el-form-item prop="re_password" label="重复密码" class="re_password">
									<el-input :size="$store.state.width<$store.state.minwidth?'small':''" v-model="Info.re_password" placeholder="请重复密码" type="password"></el-input>
								</el-form-item>


								<el-button :size="$store.state.width<$store.state.minwidth?'small':''" type="primary" @click="Info_next('Info')">下一步</el-button>
							</el-form>
						</div>
						<div class="form_body4" v-if="active==2">
							<div style="margin-top: 20px;">
								<i class="el-icon-success" style="font-size: 38px;color: #42B983;"></i>
								<span style="font-size: 38px;">恭喜你！注册成功</span>
								<br /><br />
								<p style="font-size: 18px;">请返回首页进行登录</p>
								<br />
								<el-button :size="$store.state.width<$store.state.minwidth?'small':''" @click="$router.push('/login')">返回首页</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-main>

			<el-footer class="footer" height="160px" v-if="$store.state.width>$store.state.minwidth">
				<el-row class="footer_01">
					<el-col :span="4">
						<div class="smalldiv_1 public">
							&nbsp;
						</div>
					</el-col>
					<el-col :span="7">
						<div class="smalldiv_3 public">
							<div>
								<p>公司电话：028-87972089</p>
								<p>公司邮箱：1615689090@qq.com</p>
								<p>公司地址：成都市高新西区天辰路88号6栋三单元301</p>
							</div>
						</div>
					</el-col>
					<el-col :span="9">
						<div class="smalldiv_4 public">
							<div>
								<p> </p>
								<p>官网：<a style="color: blue;" href="http://www.farmereasy.com/" target="view_window">www.farmereasy.com</a></p>
								<p>版权所有：成都市易农科技有限公司 蜀ICP备16005725号</p>
							</div>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="smalldiv_2 public">
							<div><img class="wimg" src="../assets/login/app.png" alt="" width="81"></div>
							<div class="span">APP下载</div>
						</div>
					</el-col>
				</el-row>
			</el-footer>
			<el-footer v-else height="40px">
				<el-row>
					<el-col :span="24" class="footer-phone">
						<span>技术支持：<a style="color: white;" href="http://www.farmereasy.com/" target="view_window">成都市易农科技有限公司</a></span>
					</el-col>
				</el-row>
			</el-footer>
		</el-container>

	</div>
</template>

<script>
	let _this;
	export default {
		data() {
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.Info.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				Register: {
					phone: '',
					sendcode: '',
				},
				Add: {
					province: '',
					city: '',
					city1: true,
					county: '',
					county1: true,
					village: '',
					village1: true,
					add_id: '',
				},
				province_options: [],
				city_options: [],
				county_options: [],
				village_options: [],
				Info: {
					mobile: '',
					captcha: '',
					username: '',
					password: '',
					re_password: '',
					company: '',
					city: [],
				},
				rules: {
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 6,
							message: '长度在 2 到 6 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入账户密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					re_password: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}],
					city:[{
						required: true,
						message: '请输入单位地址',
						trigger: 'blur'
					}]

				},
				disabled: false,
				time: 0,
				btntxt: "重新发送",
				contentStyleObj: {
					height: '',
				},
				active: 0,
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad (node, resolve) {
						let val=node.path;
						_this.loadadr(val)
						.then((adr) => {
							resolve(adr);
						});
					}
				}
			};
		},
		mounted() {
			_this=this;
			// var toolbar = document.getElementById("header1")
			// window.addEventListener('scroll', () => {
			// 	this.offsetTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			// 	//console.log(this.offsetTop);
			// 	if (this.offsetTop > 20) {
			// 		toolbar.style.background = "rgba(75,150,250,0.9)"
			// 	} else {
			// 		toolbar.setAttribute("style", "background-color:rgba(75,150,250,0)")
			// 	}
			// }, true);
		},
		components: {},
		methods: {
			getHeight() {
				this.contentStyleObj.height = window.innerHeight - 16 + 'px';
				this.width = window.innerWidth - 16;
				this.height = window.innerHeight - 16;
			},
			next() {
				if (this.active++ > 3) this.active = 0;
			},
			//手机验证发送验证码
			sendcode() {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (this.Register.phone == '') {
					this.$message({
						message: '手机号不能为空',
						center: true
					})
					return
				}
				if (!reg.test(this.Register.phone)) {
					this.$message({
						message: '请输入正确的手机号',
						center: true
					})
					return
				} else {
					let value={
						mobile: this.Register.phone
					};
					this.send(value);
					this.time = 60;
					this.disabled = true;
					this.timer();
				}
			},
			//60S倒计时
			timer() {
				if (this.time > 0) {
					this.time--;
					this.btntxt = this.time + "s后重新获取";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.btntxt = "获取验证码";
					this.disabled = false;
				}
			},
			submitForm() {
				let value={
					mobile: this.Register.phone,
					captcha: this.Register.sendcode
				};
				this.smscheck(value)
				.then((response)=>{
					if (response.data.code == 1) {
						this.Info.mobile = this.Register.phone;
						this.Info.captcha = this.Register.sendcode;
						this.next();
					}
				})
			},
			Info_next(Info) {
				this.$refs[Info].validate((valid) => {
					if (valid) {
						this.$message({
							message: "注册中...请稍等...",
							type: 'warning',
							center: true,
						});
						let value={
							mobile: this.Info.mobile,
							captcha: this.Info.captcha,
							city: this.adrtrans(this.Info.city),
							company: this.Info.company,
							username: this.Info.username,
							password: this.Info.password,
						};
						this.register(value)
						.then((response) => {
							if(response.data.code == 1) {
								this.next();
							}
						});
					} else {
						this.$message({
							message: "请仔细核对错误信息！",
							type: 'error',
							center: true,
						});
						return false;
					}
				});
			}
		}
	}
</script>

<style scoped>
	a {
		text-decoration: none;
		color: #444444;
	}

	.bg {
		/* position: relative; */
		/* overflow: hidden; */
		/* height: 100%; */
		/* display: flex; */
		/* height: 900px; */
		/* justify-content: center;
		align-items: center; */
		/* background-color: lightskyblue; */
		/* background-image: url(../../img/login_bg.png);
		background-position: -20% 10%; 
		background-size: cover;
		background-repeat: no-repeat; */
	}
	.width{
		width: 100%;
	}

	.header1 {
		background-color: lightskyblue;
	}

	.logo {
		margin: 10px;
		cursor: pointer;
	}

	.home-btn {
		position: absolute;
		color: white;
		font-size: 28px;
		top: 5px;
		right: 30px;
	}

	.home-btn a {
		color: royalblue;
	}


	.big {
		height: 240;
		width: 100%;
		/* background-color:  skyblue; */
	}

	.form_bg {
		/* padding: 10px; */
		width: 100%;
		background-color: white;
		/* position: absolute; */
		top: 70px;
		left: 0px;
		overflow: hidden;
	}

	.form_header {
		margin-top: 20px;
	}

	.form_body {
		margin-top: 10px;
		text-align: center;
		z-index: 100;

		/* box-shadow: 0px 0px 0px 5px rgba(0, 0, 0, 0.1); */
	}

	.form_body1 {
		margin-top: 10px;
		text-align: center;
		/* position: relative; */

	}

	.root {
		width: 90%;
		max-width: 350px;
		/* position: absolute;
		left: 350px; */
		margin: 0 auto;
	}

	.form_body2 {
		margin-top: 10px;
		text-align: center;
	}

	.form_body3 {
		margin-top: 10px;
		text-align: center;
	}


	.InfoForm {
		width: 90%;
		max-width: 350px;
		margin: 0 auto;
	}
	
	.form_body4 {
		margin-top: 10px;
		text-align: center;
	}

	.footer {
		background-color: lightskyblue;
	}

	.footer_01 {
		margin: 0px;
	}

	.help {
		position: relative;
	}

	.help_date {
		position: absolute;
		right: 0px;
	}
	.smalldiv_3,.smalldiv_4{
		line-height: 30px;
	}
	.smalldiv_2{
		padding-top: 30px;
	}
	.wimg{
		width: 70px;
	}
	.span{
		width: 70px;
		text-align: center;
	}
	.footer-phone{
		line-height: 40px;
		text-align: center;
		color: white;
		font-size: 14px;
		background-color: lightskyblue;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.logo{
			width: 280px;
			height: 40px;
		}
		.header1{
			text-align: center;
			/* background-color: rgb(0,0,0,0.5);
			background-color: rgba(0,0,0,0.5); */
		}
		.el-main,.el-footer{
			padding: 0;
		}
	}
</style>
